import { useRouter } from 'next/router';
import {
  Button,
  Filter,
  FilterRow,
  Location,
  NewSearchBarPlaceholderContainer
} from './styled';
import { SEARCH_RESULT_ROUTES } from '../../../utils/helpers/constants';

export const NewSearchBarPlaceholder = () => {
  const router = useRouter();
  const isLandingPage = [
    SEARCH_RESULT_ROUTES.SALE,
    SEARCH_RESULT_ROUTES.RENT,
    SEARCH_RESULT_ROUTES.RENT_DAILY,
    SEARCH_RESULT_ROUTES.RENT_LONG_TERM
  ].includes(router.asPath);
  const isSearchPage = router.pathname === '/[...search]' && !isLandingPage;

  return (
    <NewSearchBarPlaceholderContainer $isSearchPage={isSearchPage}>
      <FilterRow>
        <Filter $isSearchPage={isSearchPage} />
        <Filter $isSearchPage={isSearchPage} />
      </FilterRow>
      <FilterRow>
        <Filter $isSearchPage={isSearchPage} />
        <Filter $isSearchPage={isSearchPage} />
      </FilterRow>

      <FilterRow>
        <Location $isSearchPage={isSearchPage} />
        <Button $isSearchPage={isSearchPage} />
      </FilterRow>
    </NewSearchBarPlaceholderContainer>
  );
};
